module.exports = __webpack_public_path__ + "static/media/bfdl_white_sdk_logo.d919c914.svg";